<template>
  <v-switch hide-details inset v-model="switchValue" :label="label" />
</template>

<script>
export default {
  name: "niko-toggle",
  props: ["value", "label"],
  computed: {
    switchValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("onChange", value);
      },
    },
  },
};
</script>
